import { differenceInMilliseconds } from 'date-fns';
import { MILLISECONDS_IN_DAY } from '../../constants';
import type { ScheduleSolversTimeConfigType } from '../../types';

export const weekDayTime = ({
  startDate,
  endDate,
  userDate
}: ScheduleSolversTimeConfigType) => {
  const viewDuration = differenceInMilliseconds(endDate, startDate);
  const fromNowToStart = differenceInMilliseconds(userDate, startDate);

  const timeFromStart = fromNowToStart % MILLISECONDS_IN_DAY;

  return viewDuration - timeFromStart;
};
